import { AdvizeoEnvironment } from './environment.interface';

export function isBetaEnvironment(env: AdvizeoEnvironment): boolean {
    return AdvizeoEnvironment.EM === env || AdvizeoEnvironment.DEV === env || AdvizeoEnvironment.LOCAL === env;
}
